import React, { Fragment } from 'react';
import './CadeComponent.css';
import { isNullOrEmpty } from '../../helpers/LanguageHelpers';

const CadeComponentDesc = (props) => {
    return (
        <Fragment>
            <h3 class="tour_analyzeConcernIcon">
                {!isNullOrEmpty(props) && !isNullOrEmpty(props.titleIcon) &&
                    <img className='cadeComponent_DescTitleIcon' src={props.titleIcon} alt="description" />
                }
                {props.title}
            </h3>
            {props.who != null &&
                <h4>{props.who} Responses</h4>
            }
            <span className="cadeComponent_desc" dangerouslySetInnerHTML={{__html: props.desc}}></span>
        </Fragment>
    );
}

export default CadeComponentDesc;


// WEBPACK FOOTER //
// ./src/components/CadeComponent/CadeComponentDesc.js